import { render, staticRenderFns } from "./normalPicker.vue?vue&type=template&id=22fb7712"
import script from "./normalPicker.vue?vue&type=script&lang=js"
export * from "./normalPicker.vue?vue&type=script&lang=js"
import style0 from "./normalPicker.vue?vue&type=style&index=0&id=22fb7712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports